import { createContext, useCallback, useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { createTheme, ThemeProvider } from '@mui/material'
import MensagemApp from '../servicos/config/MensagemApp'
import ProfissionalAPI from '../servicos/ProfissionalAPI'
import { IconContext } from 'react-icons/lib'
import APISemNode from "./../servicos/APISemNode";
import useChat from '../hooks/chat/useChat'
import { print } from '../servicos/Uteis'
import AppAPI from '../servicos/AppAPI'
import axios from 'axios'
import API from '../servicos/API.jsx'
import { obterGestaoVagasModulo } from '../paginas/App/gestaoVaga/gestaoVagaModuloCache.js'
// import useNomeSala from "./../paginas/App/chat/hook/useNomeSala";
// import useSalvarSala from "./../paginas/App/chat/hook/useSalvarSala";

// import { io } from 'socket.io-client';

export const ContextoGeral = createContext({})
ContextoGeral.displayName = 'contexto geral'

const theme = createTheme({
	palette: {
		action: {
			disabledBackground: "grey",
			disabled: "black"
		},
		text: {
			primary: '#000000'
		},
		primary: {
			main: '#000000',
			contrastText: '#fff'
		}
	}
})

export function ContextoGeralProvider({ children }) {
	const [dados, setDados] = useState({
		bottom: 1, left: -4
	})

	const [erroRequisicao, setErroRequisicao] = useState(null)
	const [centralAjuda, setCentralAjuda] = useState(null)
	// Módulo Gestão de vagas: carregado uma vez por sessão aqui no provider.
	// Antes cada página remontava o Menu e refazia /gestaoVagasModuloAtivo.
	const [gestaoVagasModulo, setGestaoVagasModulo] = useState({
		ativo: false,
		quantidade: 0,
		info: null,
		carregado: false
	})

	const navegar = useNavigate()

	location.state = {}
	location.state.conversa = 'central';

	// Listener para capturar erros do axios
	useEffect(() => {
		const handleAxiosError = (event) => {
			const erroInfo = event.detail
			setErroRequisicao(erroInfo)
		}

		window.addEventListener('axios-error', handleAxiosError)

		return () => {
			window.removeEventListener('axios-error', handleAxiosError)
		}
	}, [])

	const recarregarGestaoVagasModulo = useCallback(async ({ forcar = true } = {}) => {
		if (!dados?.dominio || !dados?.idProf || !dados?.token) {
			setGestaoVagasModulo({ ativo: false, quantidade: 0, info: null, carregado: true })
			return
		}
		try {
			const { geo, resposta } = await obterGestaoVagasModulo(dados, { forcar })
			if (!geo) {
				setGestaoVagasModulo({ ativo: false, quantidade: 0, info: null, carregado: true })
				return
			}
			const info = resposta?.dados ?? {}
			setGestaoVagasModulo({
				ativo: resposta?.resultado === true && !!info.ativoModulo,
				quantidade: Math.max(0, Number(info.totalVagasAtivas) || 0),
				info: resposta?.resultado === true ? info : null,
				carregado: true
			})
		} catch {
			setGestaoVagasModulo({ ativo: false, quantidade: 0, info: null, carregado: true })
		}
	}, [dados?.dominio, dados?.idProf, dados?.token])

	useEffect(() => {
		recarregarGestaoVagasModulo({ forcar: false })
	}, [recarregarGestaoVagasModulo])

	function limparSessaoLocal(host = dados.dominio) {
		setDados({})

		if (window?.AndroidInterface) {
			window.AndroidInterface.saveToken('')
			if (typeof window.AndroidInterface.stopBackgroundLocation === "function") {
				window.AndroidInterface.stopBackgroundLocation()
			}
			window.AndroidInterface.reloadPage()
		} else {
			window.location.replace('/?dominio=' + host)
		}
	}

	async function deslogar() {
		let host = dados.dominio
		if (!dados.posCadastro && dados.dominio) {
			let retorno = await ProfissionalAPI.alterarStatus('OF', dados)
			if (retorno?.resultado) {
				if (!!window.AndroidInterface) print(MensagemApp.deslogado)
				else console.log(MensagemApp.deslogado)

				limparSessaoLocal(host)
			} else
				if (retorno?.resultado) {
					if (retorno.mensagem) print(retorno.mensagem ?? "")
					navegar('/app/home')
				} else if (retorno.mensagem) print(retorno.mensagem)
		} else {
			limparSessaoLocal(host)
		}
	}

	useEffect(() => {
		if (dados != undefined) {

			if (window.location.pathname == "/relatar")
				return
			if (!!dados?.config?.corPrincipal) {
				theme.palette.primary.main = dados.config.corPrincipal
				theme.palette.text.primary = dados.config.corPrincipal
			}

			if (Object.keys(dados).length === 0) {
				if (!!window.AndroidInterface) {
					if (typeof window.AndroidInterface.recoverToken === "function") {

						let token = window.AndroidInterface.recoverToken()

						if (token !== '') {
							if (typeof window.AndroidInterface.recoverdomain === "function") {
								let host = window.AndroidInterface.recoverdomain()
								if (host != '') {
									let rota = `/?dominio=${host}`
									navegar(rota)
								}
							}
						}
					}
				} else navegar('/')
			} else if (dados.dominio === undefined) navegar('/')
		} else navegar('/')
	}, [dados])

	useEffect(() => {
		const ver = window.AndroidInterface?.recoverVersion() ?? null

		if (ver && dados.dominio) AppAPI.validarVersao(dados.dominio, ver).then(res => {
			if (!res.resultado) {
				navegar("/bloqueio", {
					state: {
						msg: res.mensagem,
						link: res.dados.linkGooglePlay
					}
				})
			}
		}).catch(rej => {
			console.log(rej)
		})
	}, [dados])


	if (dados == {}) {
		if (!!window.AndroidInterface) {
			if (typeof window.AndroidInterface.recoverdomain === "function") {
				setDados(dados => ({
					...dados,
					dominio: window.AndroidInterface.recoverdomain()
				}))
			}
		}
	}

	return (
		<ContextoGeral.Provider value={{ dados, setDados, deslogar, limparSessaoLocal, erroRequisicao, setErroRequisicao, centralAjuda, setCentralAjuda, gestaoVagasModulo, recarregarGestaoVagasModulo }}>
			<IconContext.Provider value={{ style: { verticalAlign: 'center' } }}>
				<ThemeProvider theme={theme}>
					{/* {Object.keys(dados).length > 0 && (
						<ChatManager dados={dados} setDados={setDados} setWebsocket={setWebsocket} />
					)} */}
					{children}
				</ThemeProvider>
			</IconContext.Provider>
		</ContextoGeral.Provider>
	)
}
